module.exports = __webpack_public_path__ + "static/media/pagina-em-construcao.06d75aa1.jpg";